__webpack_require__.i.push((options) => {
	const originalFactory = options.factory;
	options.factory = (moduleObject, moduleExports, webpackRequire) => {
		__webpack_require__.$Refresh$.init();
		try {
			originalFactory.call(this, moduleObject, moduleExports, webpackRequire);
		} finally {
			__webpack_require__.$Refresh$.cleanup(options.id);
		}
	}
})

__webpack_require__.$Refresh$ = {
	init: () => {
		__webpack_require__.$Refresh$.cleanup = () => (undefined);
		__webpack_require__.$Refresh$.register = () => (undefined);
		__webpack_require__.$Refresh$.runtime = {};
		__webpack_require__.$Refresh$.signature = () => ((type) => (type));
	},
	setup: (currentModuleId) => {
		const prevCleanup = __webpack_require__.$Refresh$.cleanup;
		const prevReg = __webpack_require__.$Refresh$.register;
		const prevSig = __webpack_require__.$Refresh$.signature;

		__webpack_require__.$Refresh$.register = (type, id) => {
			const typeId = currentModuleId + " " + id;
			__webpack_require__.$Refresh$.runtime.register(type, typeId);
		}

		__webpack_require__.$Refresh$.signature = __webpack_require__.$Refresh$.runtime.createSignatureFunctionForTransform;

		__webpack_require__.$Refresh$.cleanup = (cleanupModuleId) => {
			if (currentModuleId === cleanupModuleId) {
				__webpack_require__.$Refresh$.register = prevReg;
				__webpack_require__.$Refresh$.signature = prevSig;
				__webpack_require__.$Refresh$.cleanup = prevCleanup;
			}
		}
	},
};